//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"NumberOfTrackPoints",0,0]],[[["name","radiusId","tpNumber","angle","radius","xOffset","yOffset","adjustReg","cutcomReg"],"Create",{R_:{pointTag:"NXObject"}},9,0],[["pointTag","name","radiusId","tpNumber","angle","radius","xOffset","yOffset","adjustReg","cutcomReg"],"Modify",{},10,0],[["pointTag"],"Delete",{},1,0],[["pointTag","name","radiusId","tpNumber","angle","radius","xOffset","yOffset","adjustReg","cutcomReg"],"Get",{},1,0],[["position"],"GetTrackPoint",{R_:{track_point:"NXObject"}},1,0]],[]];
SPLM.CAM.TrackingBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TrackingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;